export enum SourceEnum {
    FINAL_PRODUCT = "finalProduct",
    FINAL_PRODUCT_MULTIPLE = 'finalProductMultiple',
    PACKAGING = "packaging",
    PACKAGING_MULTIPLE = "packagingMultiple",
}
